import { AxiosInstance } from 'axios';
import { PushSatisfactionInput } from './inputs';
import { UserRef } from './refs';

export default class ClientFeedback {
    private basePath = '/api/client-feedback';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Push new satisfaction response
    pushSatisfaction = async (input: PushSatisfactionInput): Promise<UserRef> => {
        const { data } = await this.http.post(`${this.basePath}/satisfaction`, input);

        return data;
    };
}
